import { render, staticRenderFns } from "./show-role.vue?vue&type=template&id=359e5f28&"
import script from "./show-role.vue?vue&type=script&lang=js&"
export * from "./show-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports